import StaffMemberContractForm from './StaffMemberContractForm.container';

export default StaffMemberContractForm;
